import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { authClient } from "./platform";

// Tracks the navio-platform identity session. F0.2 auth → F0.6 gated render.
export function useSession() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void authClient.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    const { data } = authClient.auth.onAuthStateChange((_event, next) => {
      setSession(next);
    });
    return () => data.subscription.unsubscribe();
  }, []);

  return { session, loading };
}
